import React from 'react'

export default function CategoriesIcon(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
    >
      <g clipPath="url(#clip0_22384_19682)">
        <path
          d="M10.692 1.81436C10.4749 1.71532 10.239 1.66406 10.0004 1.66406C9.76172 1.66406 9.52585 1.71532 9.30871 1.81436L2.16704 5.06436C2.01917 5.12956 1.89344 5.23636 1.80518 5.37174C1.71692 5.50712 1.66992 5.66525 1.66992 5.82686C1.66992 5.98847 1.71692 6.1466 1.80518 6.28198C1.89344 6.41736 2.01917 6.52416 2.16704 6.58936L9.31704 9.84769C9.53418 9.94674 9.77005 9.99799 10.0087 9.99799C10.2474 9.99799 10.4832 9.94674 10.7004 9.84769L17.8504 6.59769C17.9983 6.53249 18.124 6.42569 18.2122 6.29031C18.3005 6.15493 18.3475 5.99681 18.3475 5.83519C18.3475 5.67358 18.3005 5.51545 18.2122 5.38007C18.124 5.24469 17.9983 5.1379 17.8504 5.07269L10.692 1.81436Z"
          stroke="#9CA3AF"
          strokeWidth="1.66667"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M1.66699 10C1.6666 10.1594 1.71192 10.3155 1.79759 10.45C1.88326 10.5844 2.00568 10.6914 2.15033 10.7583L9.31699 14.0167C9.533 14.1145 9.76738 14.1651 10.0045 14.1651C10.2416 14.1651 10.476 14.1145 10.692 14.0167L17.842 10.7667C17.9895 10.7004 18.1145 10.5926 18.2018 10.4564C18.2891 10.3203 18.3349 10.1617 18.3337 10"
          stroke="#9CA3AF"
          strokeWidth="1.66667"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M1.66602 14.1641C1.66562 14.3235 1.71095 14.4796 1.79662 14.614C1.88228 14.7484 2.0047 14.8555 2.14935 14.9224L9.31602 18.1807C9.53202 18.2785 9.7664 18.3291 10.0035 18.3291C10.2406 18.3291 10.475 18.2785 10.691 18.1807L17.841 14.9307C17.9885 14.8644 18.1136 14.7566 18.2009 14.6205C18.2882 14.4844 18.334 14.3258 18.3327 14.1641"
          stroke="#9CA3AF"
          strokeWidth="1.66667"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
      <defs>
        <clipPath id="clip0_22384_19682">
          <rect width="20" height="20" fill="white" />
        </clipPath>
      </defs>
    </svg>
  )
}
